const BooksCatalog = () => import("@/views/modules/books/Catalog.vue");
const SingleBook = () => import("@/views/modules/books/SingleBook.vue");
const FavoriteBooks = () => import("@/views/modules/books/FavoriteBooks.vue");

const subdomainsPortal = [
  import.meta.env.VITE_MAIN_SUBDOMAIN,
  import.meta.env.VITE_TEST_SUBDOMAIN,
];

export default [
  {
    path: "/books/catalog",
    name: "books-catalog",
    component: BooksCatalog,
    meta: { allowedSubdomains: subdomainsPortal },
  },
  {
    path: "/books/:id",
    name: "single-book",
    component: SingleBook,
    meta: { requiresAuth: true, allowedSubdomains: subdomainsPortal },
  },
  {
    path: "/my-profile/favorite-books",
    name: "favorite-books",
    component: FavoriteBooks,
    meta: { requiresAuth: true, allowedSubdomains: subdomainsPortal },
  },
];
